<template>
  <div class="customer-list-container">
    <h2>客户管理</h2>
    <div class="header-actions" v-if="isAdmin">
      <button class="action-btn primary" @click="showAddDialog = true">➕ 新增客户</button>
    </div>
    
    <!-- 桌面端表格 -->
    <table class="customer-table desktop-table">
      <thead>
        <tr>
          <th>序号</th>
          <th>用户名</th>
          <th>密码</th>
          <th>项目名称</th>
          <th>客户类别</th>
          <th v-if="isAdmin">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(customer, idx) in customers" :key="customer.id || idx">
          <td>{{ (page - 1) * pageSize + idx + 1 }}</td>
          <td>{{ customer.user }}</td>
          <td>{{ customer.password }}</td>
          <td>{{ customer.projectName || '-' }}</td>
          <td>
            <span v-if="customer.type == 1" style="background:#ff4d4f;color:#fff;padding:2px 10px;border-radius:4px;">A类</span>
            <span v-else-if="customer.type == 2" style="background:#1890ff;color:#fff;padding:2px 10px;border-radius:4px;">B类</span>
            <span v-else>{{ customer.type }}</span>
          </td>
          <td v-if="isAdmin">
            <button class="action-btn" @click="openEditDialog(customer)">编辑</button>
            <button class="action-btn danger" @click="openDeleteDialog(customer)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- 移动端卡片列表 -->
    <div class="mobile-customer-list">
      <div v-if="customers.length === 0" class="empty-card">
        <div class="empty-content">暂无数据</div>
      </div>
      <div v-else>
        <div v-for="(customer, idx) in customers" :key="customer.id || idx" class="customer-card">
          <div class="customer-card-header">
            <span class="card-index">#{{ (page - 1) * pageSize + idx + 1 }}</span>
            <span class="card-username">{{ customer.user }}</span>
          </div>
          <div class="card-content">
            <div class="info-row">
              <span class="label">密码：</span>
              <span class="value">{{ customer.password }}</span>
            </div>
            <div class="info-row">
              <span class="label">项目：</span>
              <span class="value">{{ customer.projectName || '未分配' }}</span>
            </div>
            <div class="info-row">
              <span class="label">类别：</span>
              <span class="value">
                <span v-if="customer.type == 1" style="background:#ff4d4f;color:#fff;padding:2px 10px;border-radius:4px;">A类</span>
                <span v-else-if="customer.type == 2" style="background:#1890ff;color:#fff;padding:2px 10px;border-radius:4px;">B类</span>
                <span v-else>{{ customer.type }}</span>
              </span>
            </div>
          </div>
          <div class="card-actions" v-if="isAdmin">
            <el-button size="mini" type="primary" @click="openEditDialog(customer)">编辑</el-button>
            <el-button size="mini" type="danger" @click="openDeleteDialog(customer)">删除</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-pagination-bar">
      <span class="table-count-bottom">
        共{{ total }}条数据 | 第{{ page }} / {{ totalPages }}页
      </span>
      <button class="page-arrow" :disabled="page <= 1" @click="goPrevPage">
        <i class="el-icon-arrow-left"></i>
      </button>
      <button class="page-arrow" :disabled="page >= totalPages" @click="goNextPage">
        <i class="el-icon-arrow-right"></i>
      </button>
    </div>
    <!-- 新增客户弹窗 -->
    <div v-if="showAddDialog && isAdmin" class="dialog-mask">
      <div class="dialog-box">
        <h3>新增客户</h3>
        <form @submit.prevent="handleAddCustomer">
          <div class="form-group">
            <label>用户名</label>
            <input v-model="addForm.user" type="text" placeholder="请输入用户名" required />
          </div>
          <div class="form-group">
            <label>密码</label>
            <input v-model="addForm.password" type="password" placeholder="请输入密码" required />
          </div>
          <div class="form-group">
            <label>客户姓名</label>
            <input v-model="addForm.customer" type="text" placeholder="请输入客户姓名" required />
          </div>
          <div class="form-group">
            <label>电话</label>
            <input v-model="addForm.phone" type="text" placeholder="请输入电话" required />
          </div>
          <div class="form-group">
            <label>项目名称</label>
            <el-select v-model="addForm.projectName" placeholder="请选择项目" style="width: 100%"
              :no-data-text="'无匹配项目'"
              @change="handleProjectNameChange"
            >
              <el-option v-for="project in filteredProjectList" :key="project.id" :label="project.name" :value="project.name" />
            </el-select>
          </div>
          <div class="form-group">
            <label>客户类别</label>
            <el-select v-model="addForm.type" placeholder="请选择客户类别" style="width: 100%" required disabled>
              <el-option label="A类客户" value="1" />
              <el-option label="B类客户" value="2" />
            </el-select>
            <!-- 客户类别由项目名称自动匹配，不可手动选择 -->
          </div>
          <div class="dialog-actions">
            <button type="submit" class="action-btn primary" :disabled="addLoading">{{ addLoading ? '提交中...' : '提交' }}</button>
            <button type="button" class="action-btn" @click="handleAddCancel">取消</button>
          </div>
          <div v-if="addError" class="add-error">{{ addError }}</div>
        </form>
      </div>
    </div>
    <!-- 编辑客户弹窗 -->
    <div v-if="showEditDialog && isAdmin" class="dialog-mask">
      <div class="dialog-box">
        <h3>编辑客户</h3>
        <form @submit.prevent="handleEditCustomer">
          <div class="form-group">
            <label>用户名</label>
            <input v-model="editForm.user" type="text" required />
          </div>
          <div class="form-group">
            <label>密码</label>
            <input v-model="editForm.password" type="text" required />
          </div>
          <div class="form-group">
            <label>客户姓名</label>
            <input v-model="editForm.customer" type="text" required />
          </div>
          <div class="form-group">
            <label>电话</label>
            <input v-model="editForm.phone" type="text" required />
          </div>
          <div class="form-group">
            <label>项目名称</label>
            <el-select v-model="editForm.projectName" filterable placeholder="请选择项目" style="width: 100%" @change="handleEditProjectNameChange">
              <el-option v-for="project in projectList" :key="project.id" :label="project.name" :value="project.name" />
            </el-select>
          </div>
          <div class="form-group">
            <label>客户类别</label>
            <el-select v-model="editForm.type" placeholder="请选择客户类别" style="width: 100%" required disabled>
              <el-option label="A类客户" value="1" />
              <el-option label="B类客户" value="2" />
            </el-select>
            <!-- 客户类别由项目名称自动匹配，不可手动选择 -->
          </div>
          <div class="dialog-actions">
            <button type="submit" class="action-btn primary" :disabled="editLoading">{{ editLoading ? '提交中...' : '提交' }}</button>
            <button type="button" class="action-btn" @click="showEditDialog = false">取消</button>
          </div>
          <div v-if="editError" class="add-error">{{ editError }}</div>
        </form>
      </div>
    </div>
    <!-- 删除确认弹窗 -->
    <div v-if="showDeleteDialog && isAdmin" class="dialog-mask">
      <div class="dialog-box delete-confirm-box">
        <h3>确认删除</h3>
        <div class="delete-confirm-content">确定要删除客户 <b>{{ deleteTarget.user }}</b> 吗？</div>
        <div class="dialog-actions">
          <button class="action-btn danger" @click="handleDeleteConfirm" :disabled="deleteLoading">{{ deleteLoading ? '删除中...' : '确认' }}</button>
          <button class="action-btn" @click="showDeleteDialog = false">取消</button>
        </div>
        <div v-if="deleteError" class="add-error">{{ deleteError }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'CustomerList',
  data() {
    return {
      customers: [],
      showAddDialog: false,
      addForm: {
        user: '',
        password: '',
        customer: '',
        phone: '',
        city: '',
        time: '',
        projectName: '',
        type: '1'
      },
      addLoading: false,
      addError: '',
      projectList: [],
      isAdmin: false,
      showEditDialog: false,
      editForm: {
        id: '',
        user: '',
        password: '',
        customer: '',
        phone: '',
        city: '',
        time: '',
        projectName: '',
        type: '1'
      },
      editLoading: false,
      editError: '',
      showDeleteDialog: false,
      deleteTarget: {},
      deleteLoading: false,
      deleteError: '',
      addProjectFilter: '',
      page: 1,
      total: 0,
      totalPages: 1,
      pageSize: 10
    }
  },
  computed: {
    filteredProjectList() {
      if (!this.addProjectFilter) return this.projectList;
      return this.projectList.filter(p => p.name.toLowerCase().includes(this.addProjectFilter.toLowerCase()));
    }
  },
  created() {
    this.checkAdmin();
    this.fetchProjects();
    this.fetchCustomers();
  },
  methods: {
    async checkAdmin() {
      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        this.isAdmin = userInfo.authority == '1';
      } catch (error) {
        console.error('获取用户权限失败:', error);
        this.isAdmin = false;
      }
    },
    async fetchProjects() {
      try {
        const res = await axios.get('/api/projects');
        this.projectList = res.data.data || [];
      } catch (e) {
        this.projectList = [];
      }
    },
    async fetchCustomers(page = this.page) {
      try {
        const res = await axios.get(`/api/customers?page=${page}`);
        this.customers = res.data.data || [];
        this.total = res.data.total || 0;
        this.totalPages = res.data.totalPages || 1;
        this.page = page;
        if (this.customers.length > 0 && this.totalPages > 0) {
          this.pageSize = Math.ceil(this.total / this.totalPages);
        }
      } catch (e) {
        this.customers = [];
        this.total = 0;
        this.totalPages = 1;
      }
    },
    async handleAddCustomer() {
      this.addError = '';
      if (!this.addForm.user || !this.addForm.password || !this.addForm.customer || !this.addForm.phone || !this.addForm.projectName) {
        this.addError = '请填写所有信息';
        return;
      }
      this.addLoading = true;
      try {
        const payload = {
          user: this.addForm.user,
          password: this.addForm.password,
          customer: this.addForm.customer,
          phone: this.addForm.phone,
          city: '',
          time: new Date().toISOString(),
          projectName: this.addForm.projectName,
          type: this.addForm.type
        };
        await axios.post('/api/customers/add', payload);
        this.showAddDialog = false;
        this.addForm = { user: '', password: '', customer: '', phone: '', city: '', time: '', projectName: '', type: '1' };
        await this.fetchCustomers();
      } catch (e) {
        this.addError = '添加失败，请稍后重试';
      } finally {
        this.addLoading = false;
      }
    },
    handleAddCancel() {
      this.showAddDialog = false;
      this.addForm = { user: '', password: '', customer: '', phone: '', city: '', time: '', projectName: '', type: '1' };
    },
    openEditDialog(customer) {
      this.editForm = {
        id: customer.id,
        user: customer.user,
        password: customer.password,
        customer: customer.customer,
        phone: customer.phone,
        city: customer.city || '',
        time: customer.time || '',
        projectName: customer.projectName || '',
        type: customer.type ? String(customer.type) : '1'
      };
      this.editError = '';
      this.showEditDialog = true;
    },
    async handleEditCustomer() {
      this.editError = '';
      if (!this.editForm.user || !this.editForm.password || !this.editForm.customer || !this.editForm.phone) {
        this.editError = '请填写所有信息';
        return;
      }
      this.editLoading = true;
      try {
        const payload = {
          id: this.editForm.id,
          user: this.editForm.user,
          password: this.editForm.password,
          customer: this.editForm.customer,
          phone: this.editForm.phone,
          city: this.editForm.city || '',
          time: this.editForm.time || new Date().toISOString(),
          projectName: this.editForm.projectName || '',
          type: this.editForm.type
        };
        await axios.post('/api/customers/update', payload);
        this.showEditDialog = false;
        await this.fetchCustomers();
      } catch (e) {
        this.editError = '编辑失败，请稍后重试';
      } finally {
        this.editLoading = false;
      }
    },
    openDeleteDialog(customer) {
      this.deleteTarget = customer;
      this.deleteError = '';
      this.showDeleteDialog = true;
    },
    async handleDeleteConfirm() {
      this.deleteError = '';
      this.deleteLoading = true;
      try {
        await axios.post('/api/customers/delete', { id: this.deleteTarget.id });
        this.showDeleteDialog = false;
        await this.fetchCustomers();
      } catch (e) {
        this.deleteError = '删除失败，请稍后重试';
      } finally {
        this.deleteLoading = false;
      }
    },
    filterProject(query) {
      this.addProjectFilter = query;
    },
    handleProjectNameChange(val) {
      if (!this.projectList.some(p => p.name === val)) {
        this.addForm.projectName = '';
        return;
      }
      const project = this.projectList.find(p => p.name === val);
      if (project && (project.type === 1 || project.type === '1')) {
        this.addForm.type = '1';
      } else if (project && (project.type === 2 || project.type === '2')) {
        this.addForm.type = '2';
      }
    },
    handleEditProjectNameChange(val) {
      const project = this.projectList.find(p => p.name === val);
      if (project && (project.type === 1 || project.type === '1')) {
        this.editForm.type = '1';
      } else if (project && (project.type === 2 || project.type === '2')) {
        this.editForm.type = '2';
      }
    },
    goPrevPage() {
      if (this.page <= 1) return;
      this.fetchCustomers(this.page - 1);
    },
    goNextPage() {
      if (this.page >= this.totalPages) return;
      this.fetchCustomers(this.page + 1);
    }
  }
}
</script>

<style scoped>
.customer-list-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 24px;
}
.customer-list-container h2 {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #333;
}
.customer-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}
.customer-table th, .customer-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
}
.customer-table th {
  background: #f5f5f5;
  font-weight: 600;
  color: #333;
}
.customer-table tr:hover {
  background: #f8fafc;
}
.header-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}
.action-btn {
  background-color: #fff;
  color: #444;
  border: 1px solid #dcdfe6;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.action-btn.primary {
  background-color: #1890ff;
  color: white;
  border-color: #1890ff;
}
.action-btn.primary:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
  color: white;
}
.action-btn.danger {
  background-color: #ff4d4f !important;
  color: #fff !important;
  border-color: #ff4d4f !important;
}
.action-btn.danger:hover {
  background-color: #d9363e !important;
  border-color: #d9363e !important;
  color: #fff !important;
}
.dialog-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.18);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-box {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.13);
  padding: 32px 28px 24px 28px;
  min-width: 320px;
  max-width: 90vw;
}
.dialog-box h3 {
  margin: 0 0 18px 0;
  font-size: 20px;
  color: #333;
  text-align: center;
}
.form-group {
  margin-bottom: 18px;
}
.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #333;
  font-size: 15px;
}
.form-group input, .form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 15px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
.form-group input:focus, .form-group select:focus {
  border-color: #1890ff;
  outline: none;
}
.dialog-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 10px;
}
.add-error {
  color: #ff4d4f;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}
.table-pagination-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
}
.table-count-bottom {
  margin-right: 16px;
  font-size: 14px;
  color: #606266;
}
.page-arrow {
  background-color: #fff;
  border: 1px solid #dcdfe6;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}
.page-arrow:hover {
  background-color: #f8fafc;
}
.page-arrow:disabled {
  background-color: #f0f0f0;
  cursor: not-allowed;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .customer-list-container {
    padding: 16px;
  }
  
  .customer-list-container h2 {
    font-size: 18px;
    text-align: center;
  }
  
  .header-actions {
    justify-content: center;
  }
  
  .header-actions .action-btn {
    width: 100%;
    justify-content: center;
  }
  
  /* 桌面端表格隐藏 */
  .desktop-table {
    display: none;
  }
  
  /* 移动端卡片显示 */
  .mobile-customer-list {
    display: block;
  }
  
  .empty-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 24px;
    text-align: center;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .empty-content {
    color: #666;
    font-size: 14px;
  }
  
  .customer-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .customer-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .card-index {
    background: #1890ff;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: bold;
  }
  
  .card-username {
    font-weight: bold;
    color: #333;
    font-size: 16px;
  }
  
  .card-content {
    margin-bottom: 12px;
  }
  
  .info-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.4;
  }
  
  .info-row .label {
    color: #666;
    min-width: 60px;
    flex-shrink: 0;
  }
  
  .info-row .value {
    color: #333;
    flex: 1;
    word-break: break-all;
  }
  
  .card-actions {
    text-align: center;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    gap: 8px;
    justify-content: center;
  }
  
  /* 分页器移动端优化 */
  .table-pagination-bar {
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    overflow-x: auto;
    padding: 8px 0;
  }
  
  .table-count-bottom {
    text-align: center;
    margin-right: 0;
    min-width: auto;
  }
  
  /* 弹窗移动端优化 */
  .dialog-box {
    margin: 16px;
    max-height: 90vh;
    overflow-y: auto;
  }
}

/* 桌面端隐藏移动端卡片 */
@media (min-width: 769px) {
  .mobile-customer-list {
    display: none;
  }
  
  .desktop-table {
    display: table;
  }
}
</style> 